// Feature Flags Configuration - Production Ready Unified Architecture
export interface FeatureFlags {
  enhancedVehicles: boolean;
  enhancedVehiclesV2: boolean;
  // MPAD Enterprise Features
  productsManagement: boolean;
  shipmentsWorkflow: boolean;
  skillsManagement: boolean;
  bulkOperations: boolean;
  advancedScenarios: boolean;
  enterpriseFeatures: boolean;
}

// Main feature flags configuration
export const featureFlags: FeatureFlags = {
  enhancedVehicles: getEnvFlag('VITE_FEATURE_ENHANCED_VEHICLES', true),
  enhancedVehiclesV2: getEnvFlag('VITE_FEATURE_ENHANCED_VEHICLES_V2', true),
  
  // MPAD Enterprise Features
  productsManagement: getEnvFlag('VITE_ENABLE_PRODUCTS_CATALOG', true),
  shipmentsWorkflow: getEnvFlag('VITE_ENABLE_SHIPMENTS_WORKFLOW', true),
  skillsManagement: getEnvFlag('VITE_ENABLE_SKILLS_MANAGEMENT', true),
  bulkOperations: getEnvFlag('VITE_ENABLE_BULK_OPERATIONS', true),
  advancedScenarios: getEnvFlag('VITE_ENABLE_ADVANCED_SCENARIOS', true),
  enterpriseFeatures: getEnvFlag('VITE_ENABLE_ENTERPRISE_FEATURES', true)
};

// Helper functions for environment variable parsing
function getEnvFlag(key: string, defaultValue: boolean): boolean {
  const value = import.meta.env[key];
  if (value === undefined) return defaultValue;
  return value.toLowerCase() === 'true';
}

// Unified system is now the default (migration complete)
export const shouldUseUnifiedSystem = (): boolean => true;

// Utility functions for feature checking
export const isFeatureEnabled = (feature: keyof FeatureFlags): boolean => {
  return featureFlags[feature] as boolean;
};

// Legacy feature flag interface (for compatibility)
export const legacyFeatureFlags = {
  isEnabled: (key: string): boolean => {
    // Map environment variable names to feature flags
    const mapping: Record<string, keyof FeatureFlags> = {
      'VITE_FEATURE_ENHANCED_VEHICLES': 'enhancedVehicles',
      'VITE_FEATURE_ENHANCED_VEHICLES_V2': 'enhancedVehiclesV2',
      'VITE_ENABLE_PRODUCTS_CATALOG': 'productsManagement',
      'VITE_ENABLE_SHIPMENTS_WORKFLOW': 'shipmentsWorkflow',
      'VITE_ENABLE_SKILLS_MANAGEMENT': 'skillsManagement'
    };
    
    const flagKey = mapping[key];
    if (flagKey) {
      return featureFlags[flagKey] as boolean;
    }
    
    // Fallback to environment variable check
    return getEnvFlag(key, false);
  }
};

// Development utilities
export const logFeatureFlagState = (): void => {
  console.group('[FeatureFlags] Production Configuration');
  console.log('Feature Flags:', featureFlags);
  console.log('System: Unified Architecture (Production)');
  console.groupEnd();
};